import { Controller } from "@hotwired/stimulus"

// R4 (CONEK-6931): the only job here is opening the browser print dialog —
// the chrome-stripping itself is the page-scoped print stylesheet declared in
// packs/reporting/app/views/reports/index.html.erb, so the print behaviour
// stays a property of the page that owns it.
export default class extends Controller {
  print() {
    window.print()
  }
}
